import { FC } from "react";
import { TCardTagsProps } from "./Card.config";
import { Badge, Pill } from "../../primitives";

export const CardTags: FC<TCardTagsProps> = ({ tags }) => (
  <>
    { tags?.topLeft ? (<Pill {...tags.topLeft} className="absolute top-2 left-2"/>) : null }
    { tags?.bottomLeft ? (<Badge {...tags.bottomLeft} className="absolute left-4 bottom-0 translate-y-1/2" />) : null }
    { tags?.bottomRight ? (<Pill {...tags.bottomRight } className="absolute right-4 bottom-0 translate-y-1/2" />) : null }
  </>
);
